import { alpha } from "@mui/material/styles";

/**
 * Contrato de colores para catalog.cards.* (Productos destacados + Catálogo).
 * Propietario del valor: catalog.cards; un campo vacío HEREDA estos defaults.
 * Mantener sincronizado con el módulo homónimo de WEB_GENERICA.
 * No tomar este estilo desde visualStyle.elementColors ni de la paleta del tema:
 * el preview y la web pública deben resolver exactamente la misma precedencia.
 */
export const CATALOG_CARD_COLOR_FALLBACKS = Object.freeze({
  surface: "#FFFFFF",
  type: "#F35A3A",
  title: "#1A1A2E",
  category: "#F35A3A",
  subcategory: "#5B5D73",
  description: "#5B5D73",
  price: "#19242F",
  buttonText: "#FFFFFF",
  buttonBackground: "#F35A3A",
});

function configuredColor(value, fallback) {
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
}

export function resolveCatalogCardButtonColors(config = {}) {
  const normalBackground = configuredColor(config?.buttonBackgroundColor, CATALOG_CARD_COLOR_FALLBACKS.buttonBackground);
  const normalText = configuredColor(config?.buttonTextColor, CATALOG_CARD_COLOR_FALLBACKS.buttonText);
  return {
    background: normalBackground,
    text: normalText,
    hoverBackground: configuredColor(config?.buttonHoverBackgroundColor, normalBackground),
    hoverText: configuredColor(config?.buttonHoverTextColor, normalText),
  };
}

/** Un único CSS de CTA para la portada y /productos. Evita divergencias de hover. */
export function catalogCardButtonSx(config = {}) {
  const color = resolveCatalogCardButtonColors(config);
  return {
    color: color.text,
    bgcolor: color.background,
    borderColor: color.background,
    "&:hover": {
      color: color.hoverText,
      bgcolor: color.hoverBackground,
      borderColor: color.hoverBackground,
    },
  };
}

/**
 * Fondo de cards: alpha() de MUI no acepta todas las cadenas CSS que acepta
 * el editor (por ejemplo var(--x) o color-mix()). Preservamos rgba/hsla y
 * transparent explícitos, y evitamos que un valor permitido tire la sección.
 */
export function catalogCardBackgroundWithOpacity(value, opacity, fallback = CATALOG_CARD_COLOR_FALLBACKS.surface) {
  const candidate = typeof value === "string" && value.trim() ? value.trim() : fallback;
  if (/^(?:transparent|#[0-9a-f]{4}|#[0-9a-f]{8}|rgba\(|hsla\()/i.test(candidate)) return candidate;
  const amount = Number(opacity);
  const safeOpacity = Number.isFinite(amount) ? Math.max(0, Math.min(1, amount)) : 1;
  if (safeOpacity <= 0) return "transparent";
  if (safeOpacity >= 1) return candidate;
  try {
    return alpha(candidate, safeOpacity);
  } catch {
    return `color-mix(in srgb, ${candidate} ${Math.round(safeOpacity * 1000) / 10}%, transparent)`;
  }
}
